// utils/offlineStorage/instance.ts - utils/offlineStorage.ts split (sub-module instance)


import { OfflineStorage } from './class.js';


// Singleton instance
export const offlineStorage = new OfflineStorage();
